<div class="d-flex justify-content-between align-items-center"
  [ngStyle]="{'border-bottom':'2px solid black', 'margin-bottom':'10px'}">
  <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">FORM LIST</h2>
  <div class="d-flex align-items-center gap-3">
    <mat-icon (click)="closeDialog()" [ngStyle]="{'cursor':'pointer'}">close</mat-icon>
  </div>
</div>

                    <div class="align-items-center inline">
                        <input type="radio" (change)="showAddParticipants()" class="margin" checked id="participants"
                             name="group-1" />
                        <label for="participants">Send to selected participants</label>
                    </div> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

                    <div class="align-items-center inline">
                        <input type="radio" id="all-participants" class="margin" name="group-1"
                            (change)="hideAddParticipants()" />
                        <label for="all-participants">Send to all participants</label>
                    </div>



                    <mat-form-field *ngIf="particToggler" class="checkList" id="check">
                        <mat-label>Select the participants</mat-label>
                        <mat-select disableOptionCentering panelClass="common-drop-down-class" id-=""
                            [formControl]="toppingsControl" multiple (blur)="callTrigger()">

                            <mat-select-trigger>
                                <mat-chip-list>
                                    <mat-chip *ngFor="let topping of toppingsControl.value" [removable]="true"
                                        (removed)="onToppingRemoved(topping,0)">
                                        {{ topping.attendeeName }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip>
                                </mat-chip-list>
                            </mat-select-trigger>

                            <mat-option *ngFor="let topping of meetingResponse.attendeeList"
                                [value]="topping">{{topping.attendeeName}}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- <div class="align-items-center inline">
                        <input type="radio" class="margin"  id="singleresponse" value="single" [(ngModel)]="responseType" name="group-2" />
                        <label for="singleresponse">Single Response</label>
                    </div> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

                    <div class="align-items-center inline">
                        <input type="radio" id="multipleResponse" class="margin" name="group-2" value="multiple" [(ngModel)]="responseType"/>
                        <label for="multipleResponse">Multiple Response</label>
                    </div> -->
                    

<div contentContainer class="row">
<!-- <adc-list [data]="data" type="multiLine"></adc-list> -->
<adc-table [dataSource]="dataSource" (openLink)="openForm($event)" [noData]="noData" (searchEvent)="columnSearch($event)"></adc-table>
<adc-pagination [totalItems]="totalItems" [itemsPerPage]= "size" [itemsPerPageArr]="itemsPerPageArr" (pageChange)="pageChange($event)"
(itemsPerPageChange)="itemsPerPageChange($event)" [ngStyle]="{'margin-top':'4rem'}"></adc-pagination>
</div>